import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-variable-code-blocks',
  templateUrl: './variable-code-blocks.component.html',
  styleUrls: ['./variable-code-blocks.component.scss']
})
export class VariableCodeBlocksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
